import { useParams, useLocation } from 'react-router-dom';
import { useAxiosInterceptor } from '../../../../api/wrappers';
import HeroSection from '../../../../components/conduct-risk/HeroSection';
import ContainerDettaglioReportPage from '../../../../components/conduct-risk/dettaglio-report/ContainerDettaglioReportPage';
import { routesMap } from '../../../../routes/routesMap';

const ConductRiskDettaglioReportPage = () => {
  useAxiosInterceptor();
  const { name } = useParams<{ name: string }>();
  const location = useLocation();
  const reportName: string = decodeURIComponent(name ?? '') || 'Dettaglio Report';
  const reportId = location.state?.id as string | undefined;

  return (
    <div className="ConductRiskDettaglioReportPage">
      <HeroSection
        title={reportName}
        description="Consulta e genera i driver di analisi del report Conduct Risk."
        breadcrumbLinks={[
          { url: routesMap.HOME_PAGE, title: 'Home' },
          { url: routesMap.CONDUCT_RISK_HOME, title: 'Conduct Risk' },
          { url: routesMap.CONDUCT_RISK_REPORT_PAGE, title: 'Report' },
          { url: '#', title: reportName },
        ]}
      />
      <ContainerDettaglioReportPage reportId={reportId ?? ''} reportName={reportName} />
    </div>
  );
};

export default ConductRiskDettaglioReportPage;
